// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ClsModelsEnumsPrescriberType } from './clsModelsEnumsPrescriberType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IPrescriber {
    'deaNumber'?: string;
    'firstName': string;
    'lastName': string;
    'middleName'?: string;
    'npi': string;
    'ptan'?: string;
    'stateLicenseId'?: string;
    'suffix'?: string;
    'taxId'?: string;
    'type'?: ClsModelsEnumsPrescriberType;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IPrescriber>> = [
        {
            "name":     "deaNumber",
            "baseName": "deaNumber",
            "type":     "string"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "ptan",
            "baseName": "ptan",
            "type":     "string"
        },
        {
            "name":     "stateLicenseId",
            "baseName": "stateLicenseId",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "ClsModelsEnumsPrescriberType"
        },
    ];

    static getAttributeTypeMap() {
        return IPrescriber.attributeTypeMap;
    }
}
